import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {Helmet} from "react-helmet";
import { RESPONSE_STATUS } from '../../utils/constants';
import { Elements } from 'react-stripe-elements';
import Modal from 'react-responsive-modal';
import Api from '../../utils/api';
// import { FaFacebook, FaInstagram } from 'react-icons/fa';
import {isJSON} from '../../utils/util';

import RecommendationsCheckout from '../recommendations/RecommendationsCheckout';
import Order from '../../components/order/Order';
import LoadingBlock from '../../components/common/LoadingBlock';
import { addOrDeleteCartGoodsData,deleteAllCartGoodsData } from '../../actions/cartAction';
import './Orders.css';

class Orders extends Component {
	constructor(props) {
		super(props);
		this.state = {
			orders: [],
			productCart: [],
            productCartIds: [],
            productCartOrders: [],
            productsArrKey: [],
            discountCodes: [],
			chatMinimized: true,
			promoCodeSaved: '',
			chatGreeting: 'Any questions? Our skin advisors are here to help real-time!',
            showThankYou: false,
			loadingPurchase: false,
            productsArr: this.props.cartGoodsList,
            openPaymentConfirmModal:false,
            recommendedProducts: [],
            orderEnd:false, // Whether to complete the purchase
            orderId: '',
            orderSubtotal: 0,
		};

		this.handleReorder = this.handleReorder.bind(this);
		this.handleReturn = this.handleReturn.bind(this);
        this.syncProducts = this.syncProducts.bind(this);
        this.fun_orderPageAddProduct = this.fun_orderPageAddProduct.bind(this);
		this.clearCart = this.clearCart.bind(this);
		// this.renderOrderArr = this.renderOrderArr.bind(this);
		this.syncProductsIndividualItems = this.syncProductsIndividualItems.bind(this);
		// this.productsArr = [];
		this.price = "";
        this.idempotencyKey = Api.getUUID();

        this.authToken = Api.auth_tokenManager();
		this.userId = localStorage.getItem("user_id");
	}

	componentWillMount() {
    }
    
	componentDidMount() {
        setTimeout(this.getOrderData(),39999)
    }
    // out to page
    componentWillUnmount() {}

	forceRender = () => {
		this.setState({ loadingDone: false }, () => {
			this.setState({ loadingDone: true });
		});
    }
    
    getOrderData = ()=>{
        const userId = localStorage.getItem("user_id");
		fetch('/api/user-orders/extended-with-products?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({ orders: responseJson, loadingDone: true }, () => {
            });
        }).catch(function(err) {
            alert("There is a problem to get the orders. Please try again.");
        });
    }

	handleReorder() {
		this.setState({ chatMinimized: false, chatGreeting: 'Handle Reorder' });
	}

	handleReturn() {
		this.setState({ chatMinimized: false, chatGreeting: 'Handle Return' });
	}

	calculatePrice = () => {
        let price = 0;
        this.props.cartGoodsList.forEach(product => {
            price += parseFloat(product.price);
        });
        this.price = price.toFixed(2);
	}
    // 添加或删除购物车上产品
	syncProducts(product) {
		this.props.addOrDeleteCartGoodsData(product)
    }
    // 在订单页面上添加产品
    fun_orderPageAddProduct(product) {
	    this.props.addOrDeleteCartGoodsData(product,'orderPageAddProduct')
    }

    renderOrderArr() {
        let productsArrKey = this.state.productsArrKey;
        this.state.orders.forEach((order, index) => {
            productsArrKey.push(order.id + "-order-" + index);
        });
        this.setState({ productsArrKey: productsArrKey }); 
    }

    syncProductsIndividualItems(product) {
        let productsArrKey = this.state.productsArrKey;
        let ind = productsArrKey.indexOf(product);

        if (ind !== -1) {
            productsArrKey.splice(ind, 1);
        } else {
            productsArrKey.push(product);
        }
        this.setState({ productsArrKey: productsArrKey });
    }

    clearCart() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/clear-cart?user-id=' + userId, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
                this.setState({ productCart: [] });
                for (let key in localStorage) {
                    if (key.includes("order-") || key.includes("recommendations_") ){
                        localStorage.removeItem(key);
                    } 
                }
            } else {
                throw new Error("Response status error.");
            }
        })
        .catch((err) => {
            alert("There was a problem clearing the cart: " + err);
        });  
    }

    syncPromoCodeSaved = (discount, code, type, oncePerCustomer) => {
        let discountCodes = this.state.discountCodes;
        if (discountCodes.indexOf(code) === -1) discountCodes.push(code); 
        this.setState({ amountAvailableForDiscount: discount, discountCodes: discountCodes, promoCodeSaved: code, discountType: type, discountOncePerCustomer: oncePerCustomer });
    }

    syncShippingTax = (shipping, tax) => {
        this.setState({ shippingRate: shipping, tax: tax }, this.handleCheckout);
    }

    openPaymentConfirmModal = () => {
        const count = this.props.cartGoodsList.length;
        if (count <= 0) {
            alert("You must select at least one product.");
            return;
        }
        this.calculatePrice();
        this.setState({ openPaymentConfirmModal: true });
    }

 
    closePaymentConfirmModal = () => {
        this.setState({ openPaymentConfirmModal: false, amountAvailableForDiscount: 0, discountCodes: [], promoCodeSaved: "" });
    }

  handleCheckout = () => {
        this.setState({ openConfirmModal: false, openPaymentConfirmModal: false, loadingPurchase: true });
        let productsVariants = this.state.productsArr.map(product => {
            return product.variantId + ":1";
        });

        const userId = localStorage.getItem("user_id");
        let amountFirstPurchase = parseFloat(this.price) - this.state.amountPaidGateFee;
        let price = this.state.hasNeverPurchased && this.state.userPaidGateFee ? amountFirstPurchase : parseFloat(this.price);
        let amountAfterDiscount = 0; 

        if (this.state.discountType !== "percentage") {
            amountAfterDiscount = parseFloat(price) - parseFloat(this.state.amountAvailableForDiscount) > 0 ? parseFloat(price) - parseFloat(this.state.amountAvailableForDiscount) : 0;
        } else {
            amountAfterDiscount = price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) >= 0 ? price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) : 0;
        }
        
        let finalPricePreShippingTax = this.state.amountAvailableForDiscount > 0 ? amountAfterDiscount : price;
        let finalPrice = finalPricePreShippingTax + this.state.shippingRate + this.state.tax;
        // let discounts = this.state.hasNeverPurchased && this.state.userPaidGateFee ? parseFloat(this.state.amountAvailableForDiscount) + 10 : parseFloat(this.state.amountAvailableForDiscount);
        const url = '/api/charge-card';

        const bodyData = JSON.stringify({
                "userId": userId,
                "amount": finalPrice.toFixed(2),
                "idempotencyKey": this.idempotencyKey,
                "productVariants": productsVariants.toString(),
                "shipping": parseFloat(this.state.shippingRate).toFixed(2),
                "tax": parseFloat(this.state.tax).toFixed(2)
            }) 

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: bodyData
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
                if (this.state.promoCodeSaved.length > 0 && this.state.discountOncePerCustomer) {
                    this.redeemGiftCardInFull();
                }
                if (this.state.promoCodeSaved.length > 0) this.sendDataForRevenueTracking(localStorage.getItem("user_global_firstname"), localStorage.getItem("user_global_lastname"), localStorage.getItem("user_global_email"), this.state.promoCodeSaved, this.state.amountAvailableForDiscount, this.price, finalPrice);
                this.setState({ loadingPurchase: false, showThankYou: true }, () => {
                		this.clearCart();
                    this.sendAmountPaidForRecord(this.state.userEmail, this.price, finalPricePreShippingTax);
                });
            } else {
                this.idempotencyKey = Api.getUUID();
                this.setState({ disablePurchaseButton: false });
                throw new Error("Response status error.");
            }
        })
        .catch((err) => {
            alert("We do not have your credit card on file. Please input your credit card information by selecting “Replace with new card” in the payment method section. ");
        });
    }

   sendDataForRevenueTracking = (firstName, lastName, email, discountCode, discountAmount, orderTotal, totalPaid) => {
       if(firstName !='' && firstName != null){
           const url = 'https://hooks.zapier.com/hooks/catch/2569749/n9iu5d/';
           const discountAmountFormatted = this.state.discountType ==="percentage" ? discountAmount + "%" : "$" + discountAmount;
           const timestamp = this.renderTimestamp();
           fetch(url, {
               method: 'POST',
               body: JSON.stringify({
                   "first_name": firstName,
                   "last_name": lastName,
                   "email": email,
                   "discount_code": discountCode,
                   "discount_amount": discountAmountFormatted,
                   "order_total": orderTotal,
                   "total_paid_customer": totalPaid,
                   "timestamp": timestamp
               })
           })
           .catch(function(err) {
             alert("There was a problem sending your info. Please try again.");
           });
       }else {
            alert("user name is empty. Please login again");
       }
    }

    sendAmountPaidForRecord = (email, totalAmount, amountPaid) => {
        const url = 'https://hooks.zapier.com/hooks/catch/2569749/7o5goa/';
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                "email": email,
                "totalAmount": totalAmount,
                "amountPaid": amountPaid
            })
        })
        .catch(function(err) {
            // alert("There was a problem sending your info. Please try again.");
        });
  }

  renderTimestamp() {
        Date.prototype.toIsoString = () => {
        let tzo = -this.getTimezoneOffset(),
            dif = tzo >= 0 ? '+' : '-',
            pad = (num) => {
                var norm = Math.floor(Math.abs(num));
                return (norm < 10 ? '0' : '') + norm;
            };
        return this.getFullYear() +
            '-' + pad(this.getMonth() + 1) +
            '-' + pad(this.getDate()) +
            'T' + pad(this.getHours()) +
            ':' + pad(this.getMinutes()) +
            ':' + pad(this.getSeconds()) +
            dif + pad(tzo / 60) +
            ':' + pad(tzo % 60);
    }

    let dt = new Date();
    return dt;
    }

    toggleLoading = (loadingPurchase) => {
        this.setState({ loadingPurchase: loadingPurchase });
    }

    showThankYou = (orderIdValue,orderSubtotalValue,sourceOrderId,orderProductsDataValue, goodsNumber) => {
	
        this.setState({ showThankYou: false, openPaymentConfirmModal: false, runTutorial: false }, () => {
            for (let key in localStorage) {
                if (key.includes("order-")) localStorage.removeItem(key);
            }
        });

        localStorage.removeItem('cart-products-ids');
        this.props.history.push({pathname:"/showThankYou",state:{'orderId':orderIdValue,'orderSubtotal':orderSubtotalValue,'sourceOrderId':sourceOrderId,'orderProductsData':orderProductsDataValue,'orderGoodsNumber':goodsNumber }});

        // this.setState({
		// 	orderEnd:true, 
		// 	orderId: orderId,
		// 	orderSubtotal: orderSubtotalValue,
		// })
    }

	render() {
		const orders = this.state.orders.length > 0 ?
		 this.state.orders.map((order, index) => {
		 	return(
			 	<Order 
			 		productCart={ this.props.cartGoodsList }      // 没在使用了
                    productCartIds={ this.props.cartGoodsList } // 没有业务需求了
                     // 没在使用了
                    // productCartOrders={ this.state.productCartIds.map((id) => { return(id + "-order-" + index) }) } 
                     
			 		ordInd={ "order-" + index } 
			 		syncProducts={ this.syncProducts } 
			 		key={ index } order={ order } 
			 		handleReorder={ this.handleReorder } 
			 		handleReturn={ this.handleReturn } 
			 		productsArrKey={ this.state.productsArrKey } // 没在使用
			 		syncProductsIndividualItems={ this.syncProductsIndividualItems } // 没在使用
			 		calculatePrice={ this.calculatePrice }
			 	/>
		 	)}
		 ) :
		 "No products found."

		return (
			<div className="orders">
				<Helmet>
            <title>Order History - HelloAva</title>
        </Helmet>
        {
          this.state.loadingDone && !this.state.loadingPurchase ?
          <div>
            <div id="final-thank-you" className={this.state.showThankYou ? "checkout-block final-thank-you-block" : "checkout-block final-thank-you-block collapsed"}>
                <div className="thank-you-container"><img alt="Thank You!" src="/images/gate/thank-you.png" /></div>
                <div className="final-thank-you-message">
                    <p>
                    Your order will take about 1-2 days to process.
                    </p>
                </div>
                <div className="final-thank-you-buttons">
                    <div className="checkout-block-button hidden" >
                    <button><a href="/orders">Check order history</a></button>
                </div>
                    <div className="checkout-block-button hidden" >
                        <button><a href="/recommendations">Back to Recommendations</a></button>
                    </div>
                </div>
                <div className="social-icons">
                    <div className="follow">Follow us:</div>
                    <div className="social-icon-group">
                        {/* <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HelloAVAbeauty/"><FaFacebook size={22} className="follow-icons facebook-icon" /></a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/helloavabeauty/"><FaInstagram size={22} className="follow-icons insta-icon" /></a> */}
                        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HelloAVAbeauty/"><i className="fa fa-facebook-square fa-lg" aria-hidden="true"></i></a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/helloavabeauty/"><i className="fa fa-instagram fa-lg" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            <div className={this.state.showThankYou ? "order-body collapsed" : "order-body" }>
    				<div className="title">Order History</div>
      				{ orders }
      				{
                this.state.orders && this.state.orders.length > 0 ?
                <div className="checkout-section">
        					<button className="view-my-recommendations-button" onClick={ this.openPaymentConfirmModal }>
        						View Cart
        					</button>
        				</div> :
                null
              }
            </div>
          </div> :
          this.state.loadingPurchase ?
          <LoadingBlock purchase={ true } /> :
          <LoadingBlock purchase={ false } orders={true} />
        }

		<Modal open={ this.state.openPaymentConfirmModal } onClose={ this.closePaymentConfirmModal.bind(this) }
              classNames={{ overlay: 'ha-overlay payment-confirm-overlay', modal: 'ha-modal payment-confirm-modal', closeIcon: 'ha-modal-close' }} focusTrapped={ true }>
            <Elements>
                <RecommendationsCheckout
                    syncShippingTax={ this.syncShippingTax }
                    // productArr={ this.state.productsArr }
                    productArr={ this.props.cartGoodsList }
                    handleCheckout={ this.handleCheckout }
                    syncPromoCodeSaved={ this.syncPromoCodeSaved }
                    price={ this.price }
                    amountAvailableForDiscount={ this.state.amountAvailableForDiscount }
                    discountCodes={ this.state.discountCodes }
                    amountPaidGateFee={ this.state.amountPaidGateFee }
                    name={ localStorage.getItem("user_global_firstname") + " " + localStorage.getItem("user_global_lastname") }
                    forceRender={ this.forceRender }
                    syncProducts={ this.syncProducts }
                    toggleLoading={ this.toggleLoading }
                    showThankYou={ this.showThankYou }
                    clearCart={ this.props.deleteAllCartGoodsData }
                    hasNotPurchased={ false }
                />
            </Elements>
        </Modal>
				
				{/* <MessengerCustomerChat
                    pageId={ process.env.REACT_APP_FACEBOOK_PAGE_ID }
                    appId={ process.env.REACT_APP_FACEBOOK_APP_ID }
                    htmlRef={ process.env.REACT_APP_FACEBOOK_HTML_REF }
                    loggedInGreeting={ this.state.chatGreeting }
					minimized={ this.state.chatMinimized }
                /> */}
                {/* 判断是否完成购买 */}
                {
                    this.state.orderEnd ?
                    <div>
                        <img src={`https://www.shareasale.com/sale.cfm?tracking=${this.state.orderId}&amount=${this.state.orderSubtotal}&merchantID=77400&transtype=sale&sscidmode=6&sscid=${Api.fun_shareasaleGetCookie()}` } width="1" height="1"/>
                        <script defer async type="text/javascript" src="https://shareasale-analytics.com/j.js"></script>
                    </div>:<div></div>
                }
			</div>
		);
	}
}

function mapStateToProps(state) {
    const { helloava } = state;
    const { cartGoodsCount,cartGoodsList, cartPriceSum } = helloava.myCart;
    return { cartGoodsCount,cartGoodsList, cartPriceSum };
}

function mapDispatchToProps(dispatch) {
    return {
        addOrDeleteCartGoodsData: (product,orderPageAddProduct) => dispatch(addOrDeleteCartGoodsData(product)),
        deleteAllCartGoodsData: () => dispatch(deleteAllCartGoodsData()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Orders));



// WEBPACK FOOTER //
// ./src/views/order/Orders.js